import { ComponentProps, memo, MouseEvent, ReactNode, useCallback } from 'react'
import { OptionTemplate } from '@cargomart/ui'
import { Link as RouterLink, useNavigate } from '@tanstack/react-router'
import cn from 'classnames'

export interface IMenuItemProps extends Omit<ComponentProps<'div'>, 'ref'> {
  Icon?: TSvgIconComponent
  children?: ReactNode
  className?: string
  href?: string
  iconClassName?: string
  isActive?: boolean
  isDisabled?: boolean
  isHover?: boolean
  onClick?: (e: MouseEvent) => void
  target?: string
  to?: ComponentProps<typeof RouterLink>['to']
}

export const MenuItem = memo(function MenuItem({
  Icon,
  children,
  className,
  href,
  iconClassName,
  isActive,
  isDisabled,
  isHover,
  onClick,
  target,
  to,
  ...rest
}: IMenuItemProps) {
  const navigate = useNavigate()

  const handleClick = useCallback(
    (event: MouseEvent) => {
      event.preventDefault()
      onClick?.(event)
      if (href) {
        window.open(href, target)

        return
      }
      if (to) {
        navigate({ to })
      }
    },
    [href, onClick, target, to, navigate]
  )

  return (
    <OptionTemplate
      {...rest}
      active={isActive}
      className={cn(className, 'text-left')}
      disabled={isDisabled}
      hovered={isHover}
      onClick={handleClick}
      prefix={Icon && <Icon className={iconClassName} />}
      title={children}
    />
  )
})
